
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SchematicGridEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawSchematic = (x: number, y: number, s: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.globalAlpha *= 0.3;
             
             // Box with inner parts
             ctx.strokeRect(-s/2, -s/2, s, s);
             ctx.beginPath();
             ctx.moveTo(-s/2, 0); ctx.lineTo(s/2, 0);
             ctx.arc(0, 0, s/4, 0, Math.PI * 2);
             ctx.stroke();

             // Text labels (fake)
             ctx.fillStyle = pc.color;
             ctx.font = `${8 * scale}px monospace`;
             ctx.fillText(`ID: ${Math.floor(this.pseudoRandom(x) * 1000)}`, -s/2, -s/2 - 5);
             ctx.fillText(`STAT: OK`, -s/2, s/2 + 10);
             ctx.restore();
        };

        const draw = () => {
             // Main Grid
             ctx.save();
             ctx.globalAlpha *= 0.1;
             for (let x = x1; x <= x2; x += spacing/4) {
                 ctx.beginPath(); ctx.moveTo(x, -height * 2); ctx.lineTo(x, height * 2); ctx.stroke();
             }
             for (let y = y1; y <= y2; y += spacing/4) {
                 ctx.beginPath(); ctx.moveTo(-width * 2, y); ctx.lineTo(width * 2, y); ctx.stroke();
             }
             ctx.restore();

            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    if (this.pseudoRandom(x + y) > 0.6) {
                        drawSchematic(x, y, spacing * 0.6 * scale);
                    }
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
